import { render, staticRenderFns } from "./DocTable.vue?vue&type=template&id=75d43d11&"
import script from "./DocTable.vue?vue&type=script&lang=js&"
export * from "./DocTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports